'use client';

import type { ReactNode } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import main from '@/messages/en-AU.json';
import club from '@/messages/club/en-AU.json';
import federation from '@/messages/federation/en-AU.json';

// Static imports inside a client module: the bundle ships as a cached JS chunk,
// not as RSC props serialised into every page (see src/i18n/client/index.ts).
const messages = { ...main, ...club, ...federation };

export default function enAUMessages({ children }: { children: ReactNode }) {
  return (
    <NextIntlClientProvider messages={messages} locale="en-AU" timeZone="Australia/Sydney">
      {children}
    </NextIntlClientProvider>
  );
}
